var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRankIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.3203 6C9.34331 6 6.59031 6.938 4.32031 8.52V2C4.32031 0.895 5.21531 0 6.32031 0H18.3203C19.4253 0 20.3203 0.895 20.3203 2V8.52C18.0503 6.938 15.2973 6 12.3203 6ZM24.3203 20C24.3203 26.629 18.9453 32 12.3203 32C5.69131 32 0.320312 26.629 0.320312 20C0.320312 13.375 5.69131 8 12.3203 8C18.9453 8 24.3203 13.375 24.3203 20ZM20.3203 20C20.3203 15.582 16.7383 12 12.3203 12C7.90231 12 4.32031 15.582 4.32031 20C4.32031 24.418 7.90231 28 12.3203 28C16.7383 28 20.3203 24.418 20.3203 20ZM12.3203 14C9.00431 14 6.32031 16.688 6.32031 20C6.32031 23.316 9.00431 26 12.3203 26C15.6323 26 18.3203 23.316 18.3203 20C18.3203 16.688 15.6323 14 12.3203 14Z",
    fill: "#394AB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankIcon);
export default __webpack_public_path__ + "static/media/rankIcon.142cb32ed22b0c771eff0c664c38b37d.svg";
export { ForwardRef as ReactComponent };